import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=90a4d98c&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=90a4d98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a4d98c",
  null
  
)

export default component.exports